/**
 * region for libraries*/
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom'

export class NavigationMenu extends Component {
    static displayName = NavigationMenu.name;

  constructor (props) {
    super(props);
      this.state = {
          modeExpanded: this.props.modeExpanded
      };

  }

    handleCollapsedSidebar(event) {
        event.preventDefault();
        const self = this;
        if (self.props.onCollapsedSidebar) {
            self.props.onCollapsedSidebar();
        }        
    }

    render() {
        let asideMenu;
        if (this.props.modeExpanded) {
            asideMenu = <aside className="site-sidebar sidebar-width navegation-menu">
                        <div className="sidebar-nav-container">
                            <nav>
                                <ul className="sidebar-nav sidebar-collapsed">
                                    <li className="sidebar-nav-item">
                                        <NavLink to="/indexActivityLog/dashboard" activeClassName="active" className="sidebar-nav-link">Dashboard</NavLink>
                                    </li>
                                    <li className="sidebar-nav-item">
                                        <NavLink to="/indexActivityLog/activity" activeClassName="active" className="sidebar-nav-link">Activity</NavLink>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <nav>
                            <ul className="sidebar-nav sidebar-bottom">
                                <li className="sidebar-nav-item" onClick={this.handleCollapsedSidebar.bind(this)}>
                                    <a className="sidebar-nav-link active d-flex justify-content-end" href="#/">
                                        <i className="fas fa-chevron-left"></i>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </aside>          
        } else {
            asideMenu = <aside className="site-sidebar sidebar-width-collapsed navegation-menu">
                        <div className="sidebar-nav-container">
                            <nav>
                                <ul className="sidebar-nav sidebar-collapsed">
                                    <li className="sidebar-nav-item">
                                        <NavLink to="/indexActivityLog/dashboard" activeClassName="active" className="sidebar-nav-link">
                                            <i className="fas fa-chart-area"></i></NavLink>
                                    </li>
                                    <li className="sidebar-nav-item">
                                        <NavLink to="/indexActivityLog/activity" activeClassName="active" className="sidebar-nav-link">
                                            <i className="fas fa-table"></i></NavLink>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <nav>
                            <ul className="sidebar-nav sidebar-bottom">
                                <li className="sidebar-nav-item" onClick={this.handleCollapsedSidebar.bind(this)}>
                                    <a className="sidebar-nav-link active d-flex justify-content-end" href="#/">
                                        <i className="fas fa-chevron-right"></i>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </aside>
        }


       return (
                <div className="keywords-log-sidebar">
                    { asideMenu }
                </div>
      );
  }

}
